import { z } from 'zod';

const NOTES_MAX = 500;

export const updateFulfilmentStatusNotesSchema = z.object({
  notes: z.string().max(NOTES_MAX),
});

export type UpdateFulfilmentStatusNotesValues = z.infer<typeof updateFulfilmentStatusNotesSchema>;

export const FULFILMENT_STATUS_NOTES_MAX = NOTES_MAX;
